import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import {
  debounceTime,
  distinctUntilChanged,
  map,
  switchMap,
} from "rxjs/operators";
import { Subject, EMPTY } from "rxjs";
import { ConfirmationService } from "primeng/api";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Address } from "../../../core/models/shared/address";
import { SalesOrderHeader } from "../../../core/models/orders/saleOrderHeader";
import { City } from "../../../core/models/shared/cityList";
import { AddressCountryRegion } from "../../../core/models/shared/countryRegionList";
import { AddressCounty } from "../../../core/models/shared/countyList";
import { District } from "../../../core/models/shared/districtList";
import { AddressState } from "../../../core/models/shared/stateList";
import { AddNewClientService } from "../../../core/services/add-new-client.service";
import { LoaderService } from "../../../core/services/loader.service";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { ClientSearchList } from "../../../core/models/shared/clientSearchList";
import { CommonModule } from "@angular/common";
import { GenericResponseDto } from "../../../core/models/generic-response.dto";
import { AddressService } from "../../../core/services/address.service";
import { GetVendorSearchResponseDto } from "../../../core/models/vendor/getVendorSearchResponseDto";
import { SelectChangeEvent, Select, SelectModule } from "primeng/select";
import { TableModule } from "primeng/table";
import { Popover, PopoverModule } from "primeng/popover";
import { DialogModule } from "primeng/dialog";
import { MelissaStatusCodes } from "../../constants/result-codes";
import { ShipToAddressDto } from "../../../core/models/shared/shipToAddress";
import { GetAllVendorsDto } from "../../../core/models/vendor/getAllVendors";
import { MelissaAddressFormatResponseDto } from "../../../core/models/shared/melissaAddressFromatResponseDto";
import {
  AutoCompleteCompleteEvent,
  AutoCompleteModule,
  AutoCompleteSelectEvent,
} from "primeng/autocomplete";
import { MelissaAddressResponseDto } from "../../../core/models/shared/mellssaAddressResponseDto";
import { ShipTo } from "../../../core/models/orders/shipTo";
import { SamplepoListingService } from "../../../core/services/samplepo-listing.service";

import { InputTextModule } from "primeng/inputtext";
import { PurchaseOrderHeader } from "../../../core/models/samplePO/details/purchaseOrderHeader";
import { QuotesHeader } from "../../../core/models/qoutes/quotesHeader";

@UntilDestroy()
@Component({
  selector: "jni-ship-to-address",
  templateUrl: "./ship-to-address.component.html",
  styleUrls: ["./ship-to-address.component.scss"],
  providers: [ConfirmationService],
  imports: [
    SelectModule,
    CommonModule,
    ReactiveFormsModule,
    TableModule,
    PopoverModule,
    DialogModule,
    AutoCompleteModule,
    InputTextModule,
  ],
})
export class ShipToAddressComponent implements OnInit, OnChanges {
  @Input() parent!: FormGroup;
  @Input() deliveryAddress: { id: number; name: string; status: boolean }[] =
    [];
  @Input() countryRegionList: AddressCountryRegion[] = [];
  @Input() cityList: City[] = [];
  @Input() stateList: AddressState[] = [];
  @Input() districtList: District[] = [];
  @Input() countyList: AddressCounty[] = [];
  @Input() customerBillToObject!: ClientSearchList;
  @Input() showAddress!: boolean;
  @Output() smallLoaderEvent = new EventEmitter<boolean>();
  @Input() addressFieldStatus!: boolean;
  @Input() editHeaderStatus!: boolean;
  public salesOrderEditCase = false;
  @Input() formgroupName!: string;
  @Input() hiddenHeadingStatus = false;
  @Input() isPrimaryFieldStatus = true;
  @Input() formErrors!: Record<string, string>;
  @Input() addressObject!: Address;
  @Input() headerObject!: SalesOrderHeader | PurchaseOrderHeader | QuotesHeader;
  @Input() shiftToAddressList!: Address[];
  @Input() shipToAddress = false;
  @Input() vendorAccountAndBook = false;
  @Input() showName = true;
  @Output() validationErrorEvent = new EventEmitter();
  @Output() multiShipToAndTbdEvent = new EventEmitter();
  @Input() isEditFromCdi = false;
  @Input() isShipToAddressFromOrder = false;
  @Input() isShipToAddressFromProposal = false;
  @Input() fromAddressAssignment = false;
  @Input() isShipToAddresssFromOrderLines = false;
  @Input() collapseStatus = false;

  formatResponse!: MelissaAddressFormatResponseDto;

  @Input() defaultOneTime = "One Time";
  // getZipCode: any[] = [];
  // getFilteredZipCode: any[] = [];

  stateSelectedId = "";
  shiftToAddressField = "";
  countryRegionSelectedId = "USA";
  address2 = "";
  address3 = "";
  city = "";
  state = "";
  postalcode = "";
  customerBillToAddress!: ShipToAddressDto;

  vendorAccountSeletion = "";
  addressBookName = "";
  billToAddressField = "";

  public nonUsandCadFieldStatus = true;
  addressFormatFieldStatus = false;

  addressValidationStatus = true;
  showSmallLoader = false;
  isAddressValidationButton = true;

  showZip = true;
  showDistrict = false;
  showPostBox = false;
  showCity = false;
  showCounty = false;
  showState = false;
  showStreetNumber = false;
  showStreet = true;
  showbuildingComplement = false;
  showAddressBook = false;
  showAppartment = false;
  showAddressValidation = false;
  showValidateAddress = false;
  showForeignCurrency = false;
  appartmentFieldStatus = false;
  public melissa!: MelissaAddressFormatResponseDto;
  public melissaForNonUsAddress1!: MelissaAddressFormatResponseDto;
  isAddressError = false;
  hideValidateButton = true;
  hideNonUsAddressSaveButton = true;
  billToFieldName = false;
  melissaSelection = "";
  selectedAppartment = "";
  appartmentList: string[] = [];
  isOpen = false;
  originalAddress = "";
  public searchVendor$ = new Subject<string>();
  vendorList: GetAllVendorsDto[] = [];
  addressBookList: Address[] = [];
  @Input() clientShipToAddressDisabled = false;
  @Input() vendorNameShipToAddressDisabled = false;
  isAddressValidatedByMelissa = true;
  melissaErrorMessage = "";
  melissaStatusCodes = MelissaStatusCodes;
  @Output() melissaAddressValidatedEvent = new EventEmitter<boolean>();
  modalOpen = false;
  isMelissaValidationIgnore = false;
  @Output() melissaValidationIgnoreEvent = new EventEmitter<boolean>();

  @ViewChild("selector") ngselect!: Select;
  showContinueWithoutValidation = false;

  nonUSSuggestions!: MelissaAddressResponseDto[];
  usSuggestions!: MelissaAddressResponseDto[];
  showAddressLinesFields = false;
  @Input() lineStatusD365 = "";

  @ViewChild("vendorShipToNameInput", { read: ElementRef })
  vendorShipToNameInput!: ElementRef<HTMLElement>;
  @ViewChild("vendoraddressbookPopOver") vendoraddressbookPopOver!: Popover;

  constructor(
    private _addNewClientService: AddNewClientService,
    private _samplepoListingService: SamplepoListingService,
    private _addressService: AddressService,
    private confirmationService: ConfirmationService,
    private _loaderService: LoaderService,
    private _toastr: JniToastrService
  ) {}

  ngOnInit(): void {
    this.getCountryRegionListData();
    this.parent.valueChanges.subscribe(data => {
      this.addressValidation(data);
    });
    this.searchVendorName();

    if (this.isEditFromCdi) {
      this.cdiEditCaseDisableFields();
    }
  }

  ngOnChanges(): void {
    if (this.isEditFromCdi) {
      this.cdiEditCaseDisableFields();
    }

    if (
      this.isShipToAddresssFromOrderLines &&
      (this.defaultOneTime === "One Time" ||
        this.defaultOneTime === "One Time Blank") &&
      this.lineStatusD365 !== "Delivered" &&
      this.lineStatusD365 !== "Invoiced" &&
      this.lineStatusD365 !== "Canceled"
    ) {
      this.enableDeliveryName();
    }
  }

  cdiEditCaseDisableFields() {
    this.parent.get(["shipTo", "addressSelectionName"])?.disable();
    this.parent.get(["shipTo", "deliveryNameD365"])?.disable();
    this.parent.get(["shipTo", "attentionInformationD365"])?.disable();
    this.parent.get(["shipTo", "addressD365"])?.disable();
    this.parent.get(["shipTo", "countryRegionIdD365"])?.disable();
    this.parent.get(["shipTo", "attention"])?.disable();
    this.parent.get(["shipTo", "locationD365"])?.disable();
    this.parent.get(["shipTo", "rSMJNIShipToEmailD365"])?.disable();
    this.parent.get(["shipTo", "shipToVendorAccountNameD365"])?.disable();
    this.parent.get(["shipTo", "addressFormat"])?.disable();
  }

  onCountryRegionSelection(countryid: string) {
    if (countryid) {
      this.parent.get(["shipTo", "zipCodeD365"])?.enable();
      this.parent.get(["shipTo", "cityD365"])?.enable();
      this.parent.get(["shipTo", "stateD365"])?.enable();
    } else {
      this.parent.get(["shipTo", "zipCodeD365"])?.disable();
      this.parent.get(["shipTo", "cityD365"])?.disable();
      this.parent.get(["shipTo", "stateD365"])?.disable();
    }

    // const countryregionid = countryid != null ? countryid : '';
    // if (countryregionid == '') {
    //   this.cityList != null ? (this.cityList.length = 0) : null;
    //   this.stateList != null ? (this.stateList.length = 0) : null;
    //   this.addressValidationStatus = true;
    //   this.updateValueOnCountrySelection();
    // } else {
    //   this.updateValueOnCountrySelection();
    //   this.filterAddressFormats(countryregionid);
    //   this.getCountyListData(countryregionid);
    //   this.getStateListData(countryregionid);
    // }

    if (countryid) {
      if (
        countryid?.toLowerCase() === "usa" ||
        countryid?.toLowerCase() === "can"
      ) {
        this.nonUsandCadFieldStatus = true;
        this.showAddress = false;
      } else {
        this.nonUsandCadFieldStatus = false;
        this.showAddress = true;

        if (!this.salesOrderEditCase) this.clearNonUsForm();
      }
    }

    this.showHideContinueWithoutValidation();
  }

  clearNonUsForm() {
    this.parent.patchValue({
      shipTo: {
        zipCodeD365: "",
        streetD365: "",
        cityD365: "",
        stateD365: "",
        addressD365: "",
        rSMJNIShipToEmailD365: "",
        addressBook: "",
        buildingComplimentD365: "",
        apartment_RUD365: "",
        postBoxD365: "",
        countyD365: "",
        streetNumberD365: "",
        districtNameD365: "",
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
      },
    });

    this.shiftToAddressField = "";
    this.vendorAccountSeletion = "";
    this.addressBookName = "";
  }

  filterAddressFormats(countryId: string) {
    const filteredRegions = this.countryRegionList.filter(
      x => x.countryRegionD365 == countryId
    );
    this.getAddressFormats(filteredRegions[0].addressFormatD365);
  }

  getAddressFormats(formatId: string) {
    this.showSmallLoader = true;
    this._addNewClientService
      .getAddressFormatsByFormatId(formatId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.filterAddressesUsingAddressFormats(res?.data?.descriptionD365);
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  filterAddressesUsingAddressFormats(description: string | null) {
    if (
      !description?.toLowerCase().includes("zip") &&
      !description?.toLowerCase().includes("postal_code") &&
      !description?.toLowerCase().includes("postcode") &&
      !description?.toLowerCase().includes("postal code")
    ) {
      this.showZip = false;
    } else {
      this.showZip = true;
    }
    if (!description?.toLowerCase().includes("district")) {
      this.showDistrict = false;
    } else {
      this.showDistrict = true;
    }
    if (!description?.toLowerCase().includes("city")) {
      this.showCity = false;
    } else {
      this.showCity = true;
    }
    if (!description?.toLowerCase().includes("county")) {
      this.showCounty = false;
    } else {
      this.showCounty = true;
    }
    if (
      !description?.toLowerCase().includes("state") &&
      !description?.toLowerCase().includes("province")
    ) {
      this.showState = false;
    } else {
      this.showState = true;
    }
    if (!description?.toLowerCase().includes("street")) {
      this.showStreet = false;
    } else {
      this.showStreet = true;
    }
    if (!description?.toLowerCase().includes("number")) {
      this.showStreetNumber = false;
    } else {
      this.showStreetNumber = true;
    }
    if (
      !description?.toLowerCase().includes("complement") &&
      !description?.toLowerCase().includes("building")
    ) {
      this.showbuildingComplement = false;
    } else {
      this.showbuildingComplement = true;
    }
    if (!description?.toLowerCase().includes("apartment")) {
      this.showAppartment = false;
    } else {
      this.showAppartment = true;
    }
    const poBox = description
      ?.toLowerCase()
      .split(",")
      .join(" ")
      .split("/")
      .join(" ")
      .split("_")
      .join(" ")
      .split(";")
      .join(" ")
      .split(" ")
      .some(x => x == "post" || x == "postbox");
    if (!poBox) {
      this.showPostBox = false;
    } else {
      this.showPostBox = true;
    }
  }

  updateValueOnCountrySelection() {
    this.parent.patchValue({
      shipTo: {
        zipCodeD365: "",
        districtNameD365: "",
        cityD365: "",
        countyD365: "",
        stateD365: "",
      },
    });
  }

  getCountyListData(id: string) {
    this.showSmallLoader = true;
    this._addNewClientService
      .getCountyList(id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.countyList = res?.data;
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  getStateListData(id: string) {
    this.showSmallLoader = true;
    this._addNewClientService
      .getStateList(id)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.stateList = res?.data;
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  // searchZipCode: OperatorFunction<string, readonly string[]> = (
  //   text$: Observable<string>
  // ) =>
  //   text$.pipe(
  //     debounceTime(200),
  //     distinctUntilChanged(),
  //     switchMap(async (term: string) =>
  //       term.length < 4
  //         ? []
  //         : (this.getFilteredZipCode = await this.getZipListData(
  //             this.countryRegionSelectedId,
  //             term
  //           ))
  //     )
  //   );

  // async getZipListData(id: string, name: string) {
  //   this.getFilteredZipCode = [];
  //   this.showSmallLoader = true;
  //   const res = await lastValueFrom(
  //     this._addNewClientService.getZipList(id, name).pipe(untilDestroyed(this))
  //   );
  //   this.getZipCode = res.data;
  //   this.showSmallLoader = false;
  //   return this.getZipCode;
  // }

  onDeliveryAddressChange(event: string, editBillTo = true) {
    this.showName = true;
    if (this.isShipToAddresssFromOrderLines) {
      this.clearShifToForm();
    }

    if (event === "One Time" || event === "One Time Blank") {
      this.enableDeliveryName();
    }

    const value = event;
    if (value === "Bill To" || value == "Bill to") {
      this.shipToAddress = false;
      this.showAddressValidation = false;
      this.showValidateAddress = false;
      this.showAddress = true;
      this.isAddressError = false;
      this.appartmentFieldStatus = true;
      this.nonUsandCadFieldStatus = true;
      this.billToFieldName = true;
      this.disableDeliveryName();
      this.disabledAddressFields();
      this.patchAddressOfCustomerBillTo();
      if (editBillTo) {
        this.patchClientBillingDetails();
      }
      this.clearValidationOnAddress();
      this.hiddenAddressFields();
      this.clearShifToForm();
      this.enableClientBillingDetails();
    } else if (
      value === "Client Address Book" ||
      value === "Client address book" ||
      value == "Address book" ||
      value == "To address book"
    ) {
      this.showName = false;
      this.shipToAddress = true;
      this.showAddressValidation = false;
      this.showValidateAddress = false;
      this.showAddress = true;
      this.isAddressError = false;
      this.appartmentFieldStatus = true;
      this.nonUsandCadFieldStatus = true;
      this.vendorAccountAndBook = false;
      this.billToFieldName = false;
      this.clientShipToAddressDisabled = false;
      this.customerBillToAddress = this.parent.get("shipTo")
        ?.value as ShipToAddressDto;
      this.disableDeliveryName();
      this.clearShifToForm();
      this.patchAddressOfCustomerAddressBook();
      this.clearValidationOnAddress();
      this.hiddenAddressFields();
      this.disabledAddressFields();
      this.enableAttentionandLocationField();
    } else if (value === "TBD") {
      this.isAddressError = false;
      this.appartmentFieldStatus = true;
      this.shipToAddress = false;
      this.nonUsandCadFieldStatus = true;
      this.billToFieldName = false;
      this.clearValidationOnAddress();
      this.clearStreetAddress();
      this.clearShifToForm();
      this.patchValueInDeliveryName("");
      this.disabledTbd();
      this.disabledAttentionandLocationField();
      this.disableDeliveryName();

      if (!this.salesOrderEditCase) {
        this.clearAttentionLocation();
      }

      this.clearValidationOnAddressMultiShipTo();
      this.enableAttentionandLocationField();
      this.multiShipToAndTbdEvent.emit(event);
    } else if (
      value === "Multi Ship To" ||
      value == "Multiple ship-to" ||
      value?.toLowerCase()?.includes("drop")
    ) {
      this.isAddressError = false;
      this.appartmentFieldStatus = true;
      this.shipToAddress = false;
      this.nonUsandCadFieldStatus = true;
      this.billToFieldName = false;
      this.enableDeliveryName();
      this.clearValidationOnAddress();
      this.clearStreetAddress();
      this.clearShifToForm();
      this.enableAttentionandLocationField();
      this.disabledMulti();
      this.clearShipToMultiForm();
      this.patchValueInDeliveryName("Multiple Drop Ships");
      this.clearValidationOnAddressMultiShipTo();
      this.multiShipToAndTbdEvent.emit(event);
      //Clears the Name field PGL-235 -
      // this.parent.patchValue({
      //   shipTo: {
      //     deliveryNameD365: ''
      //   }
      // });
    } else if (value === "To Vendor" || value == "To vendor") {
      this.showName = false;
      this.shipToAddress = false;
      this.vendorAccountAndBook = true;
      this.showAddressValidation = false;
      this.showValidateAddress = false;
      this.showAddress = true;
      this.billToFieldName = false;
      this.disableDeliveryName();
      this.clearValidationOnAddress();
      this.hiddenAddressFields();
      this.clearShifToForm();
      this.enableAttentionandLocationField();
    } else if (
      value === "To Header Ship To" ||
      value == "To header ship to" ||
      value == "To header ship-to"
    ) {
      this.shipToAddress = false;
      this.vendorAccountAndBook = false;
      this.showAddressValidation = false;
      this.showValidateAddress = false;
      this.showAddress = true;
      this.billToFieldName = false;
      if (this.addressObject) {
        this.patchFormInHeaderToShip(this.addressObject);
      }
      if (this.headerObject) {
        this.patchFormInHeaderToShipAddress(this.headerObject);
      }
      this.clearValidationOnAddress();
      this.hiddenAddressFields();
      this.disabledAttentionandLocationField();
      this.disableDeliveryName();
    } else {
      this.enableAddressFields();
      this.shipToAddress = false;
      this.showAddressValidation = true;
      this.showValidateAddress = true;
      this.showAddress = false;
      this.nonUsandCadFieldStatus = false;
      this.vendorAccountAndBook = false;
      this.billToFieldName = false;
      this.enableDeliveryName();
      this.enableMulti();
      this.enableTbd();
      this.nonUsandCadFieldStatus = true;
      if (!this.countryRegionSelectedId) {
        this.countryRegionSelectedId = "USA";
      }

      //this.appartmentFieldStatus = false;
      //this.applyValidationOnAddress();
      if (
        !(value == "One Time" || value == "One time" || value == "One time")
      ) {
        this.clearShifToForm();
        this.clearAttentionLocation();
      }
      if (value === "One Time" || value == "One time" || value == "One time") {
        this.clearValidationOnAddress();
        if (
          !this.isShipToAddressFromOrder &&
          !this.isShipToAddressFromProposal
        ) {
          this.countryRegionSelectedId = "";
        }

        this.parent.patchValue({
          shipTo: {
            countryRegionIdD365: this.countryRegionSelectedId ?? "USA",
          },
        });
      }
      this.enableAttentionandLocationField();
    }

    this.enableCountryField(event);
    this.showHideContinueWithoutValidation();
  }

  showHideContinueWithoutValidation() {
    if (
      !this.defaultOneTime?.includes("To Header") &&
      this.countryRegionSelectedId !== "" &&
      this.countryRegionSelectedId !== "USA" &&
      this.countryRegionSelectedId !== "CAN"
    ) {
      this.showContinueWithoutValidation = true;
    } else {
      this.showContinueWithoutValidation = false;
    }
  }

  enableDeliveryName() {
    this.parent.get(["shipTo", "deliveryNameD365"])?.enable();
  }

  disableDeliveryName() {
    this.parent.get(["shipTo", "deliveryNameD365"])?.disable();
  }

  clearStreetAddress() {
    this.parent.get(["shipTo", "streetD365"])?.clearValidators();
    this.parent.get(["shipTo", "streetD365"])?.updateValueAndValidity();
  }

  disabledMulti() {
    this.parent.get(["shipTo", "addressFormat"])?.disable();
    this.parent.get(["shipTo", "addressD365"])?.disable();
    this.parent.get(["shipTo", "attentionInformationD365"])?.disable();
    this.parent.get(["shipTo", "locationD365"])?.disable();
    this.parent.get(["shipTo", "deliveryNameD365"])?.disable();
  }

  enableMulti() {
    this.parent.get(["shipTo", "addressFormat"])?.enable();
    this.parent.get(["shipTo", "addressD365"])?.enable();
    this.parent.get(["shipTo", "attentionInformationD365"])?.enable();
    this.parent.get(["shipTo", "locationD365"])?.enable();
  }

  disabledTbd() {
    this.parent.get(["shipTo", "addressFormat"])?.disable();
    this.parent.get(["shipTo", "addressD365"])?.disable();
  }

  enableTbd() {
    this.parent.get(["shipTo", "addressFormat"])?.enable();
    this.parent.get(["shipTo", "addressD365"])?.enable();
  }

  disabledAttentionandLocationField() {
    this.parent.get(["shipTo", "attentionInformationD365"])?.disable();
    this.parent.get(["shipTo", "rSMJNIShipToEmailD365"])?.disable();
    this.parent.get(["shipTo", "locationD365"])?.disable();
    this.parent.get(["shipTo", "addressD365"])?.disable();
  }
  enableAttentionandLocationField() {
    this.parent.get(["shipTo", "attentionInformationD365"])?.enable();
    this.parent.get(["shipTo", "rSMJNIShipToEmailD365"])?.enable();
    this.parent.get(["shipTo", "locationD365"])?.enable();
  }

  disabledAddressFields() {
    this.parent.get(["shipTo", "zipCodeD365"])?.disable();
    this.parent.get(["shipTo", "cityD365"])?.disable();
    this.parent.get(["shipTo", "stateD365"])?.disable();
    this.parent.get(["shipTo", "streetD365"])?.disable();
    this.parent.get(["shipTo", "addressD365"])?.disable();
  }

  enableAddressFields() {
    this.parent.get(["shipTo", "zipCodeD365"])?.enable();
    this.parent.get(["shipTo", "cityD365"])?.enable();
    this.parent.get(["shipTo", "stateD365"])?.enable();
    this.parent.get(["shipTo", "streetD365"])?.enable();
    this.parent.get(["shipTo", "addressD365"])?.enable();
  }

  disableClientBillingDetails() {
    this.parent.get(["shipTo", "attentionInformationD365"])?.disable();
    this.parent.get(["shipTo", "locationD365"])?.disable();
  }

  patchClientBillingDetails() {
    if (this.customerBillToObject?.clientAccount) {
      this.smallLoaderEvent.emit(true);

      this._addNewClientService
        .getClientBillingDetails(this.customerBillToObject.clientAccount)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.smallLoaderEvent.emit(true);
            this.parent.patchValue({
              shipTo: {
                attentionInformationD365: res.data.billingAttentionD365 || "",
                locationD365: res.data.billingLocationD365 || "",
              },
            });
          },
          error: () => {
            this.smallLoaderEvent.emit(false);
          },
        });
    }
  }

  patchAddressOfCustomerBillTo() {
    this.smallLoaderEvent.emit(true);
    if (
      this.customerBillToObject?.partyNumber != undefined ||
      this.customerBillToObject?.clientAccount != undefined
    ) {
      this._samplepoListingService
        .getVendorAddressByPartyNumber(
          this.customerBillToObject?.partyNumber,
          this.customerBillToObject?.clientAccount
        )
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (res: GenericResponseDto<Address[]>) => {
            this.smallLoaderEvent.emit(false);
            if (res.data != null) {
              const primaryAddress = res.data.filter(
                x =>
                  x.isPrimaryD365?.toLowerCase() === "yes" ||
                  x.isPrimaryD365?.toLowerCase() === "1"
              );
              this.patchFormInShipToAddressField(primaryAddress[0]);
              if (this.customerBillToObject?.name) {
                this.billToAddressField = this.customerBillToObject?.name;
                this.parent.patchValue({
                  shipTo: {
                    deliveryNameD365: this.customerBillToObject?.name,
                  },
                });
              }
            }
          },
          error: () => {
            this.smallLoaderEvent.emit(false);
          },
        });
    }
  }

  clearValidationOnAddress() {
    this.parent.get(["shipTo", "addressD365"])?.clearValidators();
    this.parent.get(["shipTo", "addressD365"])?.updateValueAndValidity();
  }

  clearValidationOnAddressMultiShipTo() {
    this.parent.get(["shipTo", "addressD365"])?.clearValidators();
    this.parent.get(["shipTo", "addressD365"])?.updateValueAndValidity();
    this.parent.get(["shipTo", "countryRegionIdD365"])?.clearValidators();
    this.parent
      .get(["shipTo", "countryRegionIdD365"])
      ?.updateValueAndValidity();
    this.parent.get(["shipTo", "zipCodeD365"])?.clearValidators();
    this.parent.get(["shipTo", "zipCodeD365"])?.updateValueAndValidity();
  }

  hiddenAddressFields() {
    this.showDistrict = false;
    this.showPostBox = false;
    this.showCity = false;
    this.showCounty = false;
    this.showState = false;
    this.showStreetNumber = false;
    this.showbuildingComplement = false;
    this.showAddressBook = false;
    this.showAppartment = false;
  }

  clearAttentionLocation() {
    this.parent.patchValue({
      shipTo: {
        rSMJNIShipToEmailD365: "",
        attentionInformationD365: "",
        locationD365: "",
      },
    });
  }

  clearShifToForm() {
    this.parent.patchValue({
      shipTo: {
        countryRegionIdD365: "",
        zipCodeD365: "",
        streetD365: "",
        cityD365: "",
        stateD365: "",
        addressD365: "",
        addressBook: "",
        buildingComplimentD365: "",
        apartment_RUD365: "",
        postBoxD365: "",
        countyD365: "",
        streetNumberD365: "",
        districtNameD365: "",
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        shipToVendorAccountNameD365: "",
        shipToVendorAccountD365: "",
        deliveryNameD365: "",
        addressFormat: "",
      },
    });

    this.shiftToAddressField = "";
    this.vendorAccountSeletion = "";
    this.addressBookName = "";
    this.billToAddressField = "";
  }

  clearNewShifToForm() {
    this.parent.patchValue({
      shipTo: {
        addressSelectionName: "",
        countryRegionIdD365: "",
        zipCodeD365: "",
        streetD365: "",
        cityD365: "",
        stateD365: "",
        addressD365: "",
        addressBook: "",
        buildingComplimentD365: "",
        apartment_RUD365: "",
        postBoxD365: "",
        countyD365: "",
        streetNumberD365: "",
        districtNameD365: "",
        shipToVendorAccountNameD365: "",
      },
    });

    this.shiftToAddressField = "";
    this.vendorAccountSeletion = "";
    this.addressBookName = "";
    this.billToAddressField = "";

    this.parent.get(["shipTo", "zipCodeD365"])?.enable();
    this.parent.get(["shipTo", "cityD365"])?.enable();
    this.parent.get(["shipTo", "stateD365"])?.enable();
    this.parent.get(["shipTo", "streetD365"])?.enable();
  }

  patchAddressOfCustomerAddressBook() {
    this.showSmallLoader = true;
    if (
      this.customerBillToObject?.partyNumber != undefined ||
      this.customerBillToObject?.clientAccount != undefined
    ) {
      this._samplepoListingService
        .getVendorAddressByPartyNumber(
          this.customerBillToObject?.partyNumber,
          this.customerBillToObject?.clientAccount
        )
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (res: GenericResponseDto<Address[]>) => {
            this.showSmallLoader = false;
            if (res.data != null) {
              const primaryAddress = res.data.filter(
                x =>
                  x.isPrimaryD365?.toLowerCase() === "yes" ||
                  x.isPrimaryD365?.toLowerCase() === "1" ||
                  x.rolesD365?.toLowerCase() === "delivery"
              );
              this.shiftToAddressList = primaryAddress;
              const address = this.shiftToAddressList.filter(
                (x: Address) =>
                  x.addressD365 === this.customerBillToAddress.addressD365 &&
                  x.locationNumberD365?.toString() ===
                    this.customerBillToAddress.addressLocationNumber?.toString()
              );
              if (address.length > 0) {
                this.patchFormInShipToAddressField(address[0]);
                this.shiftToAddressField = address[0].descriptionD365 ?? "";
              }
            }
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  applyValidationOnAddress() {
    this.parent
      .get(["shipTo", "addressD365"])
      ?.setValidators(Validators.required);
    this.parent.get(["shipTo", "addressD365"])?.updateValueAndValidity();
  }

  enableCountryField(event: string) {
    const value = event;
    if (
      value &&
      (value.toLowerCase() === "one time" ||
        value.toLowerCase() === "one time blank")
    ) {
      this.parent.get(["shipTo", "countryRegionIdD365"])?.enable();
      //this.parent.get(['shipTo', 'streetD365'])?.enable();
    } else {
      this.parent.get(["shipTo", "countryRegionIdD365"])?.disable();
      //this.parent.get(['shipTo', 'streetD365'])?.disable();
    }
  }

  addressValidation(data: { shipTo: ShipTo }) {
    const addressObj = data.shipTo;
    if (
      addressObj.countryRegionIdD365 != "" &&
      addressObj.countryRegionIdD365 != null &&
      addressObj.cityD365 != "" &&
      addressObj.cityD365 != null &&
      addressObj.stateD365 != "" &&
      addressObj.stateD365 != null
    ) {
      this.isAddressValidationButton = false;
      this.parent
        .get(["shipTo", "addressD365"])
        ?.setValidators(Validators.required);
    } else {
      this.isAddressValidationButton = true;
    }
  }

  onshipToAddressFilter(event: MouseEvent, drop: Popover) {
    drop.show(event);
  }

  onShitToAddressSeletion(event: Address, shipAddressToggle: Popover) {
    shipAddressToggle.hide();
    if (event.descriptionD365 != "") {
      this.shiftToAddressField = event.descriptionD365 ?? "";
      this.parent.patchValue({
        shipTo: {
          deliveryNameD365: event.descriptionD365 ?? "",
        },
      });
    }
    this.patchFormInShipToAddressField(event);
  }

  patchFormInShipToAddressField(address: Address) {
    if (address) {
      this.parent.patchValue({
        shipTo: {
          countryRegionIdD365: address.countryRegionIdD365,
          zipCodeD365: address.zipCodeD365,
          streetD365: address.streetD365,
          cityD365: address.cityD365,
          stateD365: address.stateD365,
          countyD365: address.countyD365,
          streetNumberD365: address.streetNumberD365,
          buildingComplimentD365: address.buildingComplimentD365,
          apartment_RUD365: address.apartment_RUD365 ?? "",
          postBoxD365: address.postBoxD365,
          districtNameD365: address.districtNameD365,
          addressLocationNumber: parseInt(address.locationNumberD365 ?? "0"),
          addressD365: address?.addressD365?.replace("<br/>", "\n"),
        },
      });
    }
  }

  showAddressComponent() {
    const deliveryAddress = this.parent.get(["shipTo", "addressSelectionName"])
      ?.value as string;

    if (deliveryAddress?.toLowerCase()?.includes("one")) {
      //this.parent.get(['shipTo', 'addressD365'])?.enable();
      this.showAddress = false;
      return true;
    } else {
      this.parent.get(["shipTo", "addressD365"])?.disable();
      this.showAddress = true;
      return false;
    }
  }

  removeAddressField() {
    this.parent.patchValue({
      [this.formgroupName]: {
        addressD365: "",
      },
    });
    this.melissaSelection = "";
    this.selectedAppartment = "";
  }

  patchValueInMelissaAddressKey() {
    this.parent.patchValue({
      [this.formgroupName]: {
        melissaAddressKeyD365: this.formatResponse?.MelissaAddressKey ?? "",
      },
    });
  }

  selectedStreet(event: AutoCompleteSelectEvent) {
    const item = event.value;
    if (!item.Address.PostalCode) {
      this.melissaSelection = "";
      return;
    }
    this.removeAddressField();

    this.appartmentList = [];
    this.isOpen = true;
    this._addressService
      .checkAddressValidation(
        item.Address.Address,
        this.countryRegionSelectedId
      )
      .subscribe(x => {
        const formatResponse = x[0];
        this.formatResponse = formatResponse;
        const resultsLower = (formatResponse.Results as string).toLowerCase();
        if (formatResponse) {
          if (resultsLower?.toLowerCase()?.includes("av")) {
            this.removeValidationForAddress();
            this.isAddressError = false;
            this.hideValidateButton = true;
            this.removeValidationForAddress();
          } else {
            this.setValidationForAddress();
            this.hideValidateButton = false;
            this.isAddressError = true;
          }
          this.patchValueInMelissaAddressKey();
        }
      });

    if (item.Address.SubBuilding) {
      this.appartmentList = (item.Address.SubBuilding as string).split(",");
      this.appartmentFieldStatus = false;
      //this.selectedAppartment = this.appartmentList[0] || '';
    }
    this.melissaSelection = `${item.Address.Address1}\n${item.Address.Address2}\n${item.Address.Address3}`;
    const completeAddress = (item.Address.Address as string).replace(
      /,/g,
      "\n"
    );
    let appendedCompleteAddress = completeAddress.trim();
    //If country is USA or CAN don't append the admin area and country name to address
    if (
      this.countryRegionSelectedId !== "USA" &&
      this.countryRegionSelectedId !== "CAN"
    ) {
      appendedCompleteAddress = `${completeAddress}\n${
        item.Address.AdministrativeArea
      }\n${item.Address.CountryName}\n${this.selectedAppartment || ""}`;
    } else {
      appendedCompleteAddress = `${completeAddress}\n${
        this.selectedAppartment || ""
      }`;
    }
    this.parent.patchValue({
      [this.formgroupName]: {
        cityD365: item.Address.Locality,
        stateD365: item.Address.AdministrativeArea,
        streetD365: item.Address.Premise + " " + item.Address.Thoroughfare,
        zipCodeD365: item.Address.PostalCode,
        districtNameD365: item.Address.SubAdministrativeArea,
        postBoxD365: item.Address.PostBox,
        countyD365: item.Address.SubAdministrativeArea,
        // streetNumberD365: item.Address.Premise,
        buildingComplimentD365: item.Address.Building,
        addressD365: appendedCompleteAddress,
        melissaAddressKeyD365: this.formatResponse?.MelissaAddressKey ?? "",
      },
    });

    // this.ngselect.open();
    if (item.Address.SubBuilding) {
      this.appartmentList = (item.Address.SubBuilding as string).split(",");
      this.appartmentFieldStatus = false;
      //this.selectedAppartment = this.appartmentList[0] || '';
    }
    this.formattedAddressChange();
    this._addressService
      .getPostalCodeByZipCode(item.Address.PostalCodePrimary)
      .subscribe(res => {
        this.showSmallLoader = true;
        if (!res.data) {
          this.showSmallLoader = false;
          return;
        }
        this._addressService
          .getCityList(res.data.stateId, res.data.countryRegionId)
          .pipe(
            map(cityResponse => {
              this.cityList = cityResponse.data;

              return cityResponse.data.filter(
                city =>
                  city.cityKeyD365?.includes(res?.data?.cityId) &&
                  city.countryRegionIdD365 == res?.data?.countryRegionId &&
                  city.countyIdD365 == res?.data?.countyId &&
                  city.stateIdD365 == res?.data?.stateId
              );
            })
          )
          .pipe(untilDestroyed(this))
          .subscribe({
            next: () => {
              this.showSmallLoader = false;
            },
            error: () => {
              this.showSmallLoader = false;
            },
          });
      });

    setTimeout(() => {
      if (!item.Address.SubBuilding) {
        this.parent.patchValue({
          [this.formgroupName]: {
            addressFormat: "",
          },
        });
      }
    }, 1);
  }

  patchAddress(item: MelissaAddressFormatResponseDto) {
    if (!item.PostalCode) {
      return;
    }
    const completeAddress = item.FormattedAddress.replace(/;/g, "\n");
    let appendedCompleteAddress = completeAddress;
    if (
      this.countryRegionSelectedId !== "USA" &&
      this.countryRegionSelectedId !== "CAN"
    ) {
      const pattern = new RegExp(item.CountryName, "gi");
      appendedCompleteAddress = appendedCompleteAddress
        .replace(pattern, " ")
        .trim();
      appendedCompleteAddress = (
        appendedCompleteAddress +
        " " +
        item.CountryName
      ).trim();
    }
    this.parent.patchValue({
      [this.formgroupName]: {
        cityD365: item.Locality,
        stateD365: item.AdministrativeArea,
        streetD365: item.PremisesNumber + " " + item.Thoroughfare,
        zipCodeD365: item.PostalCode,
        districtNameD365: item.SubAdministrativeArea,
        postBoxD365: item.PostBox,
        countyD365: item.SubAdministrativeArea,
        streetNumberD365: item.PremisesNumber,
        buildingComplimentD365: item.SubPremises,
        addressD365: appendedCompleteAddress,
        melissaAddressKeyD365: this.formatResponse?.MelissaAddressKey ?? "",
      },
    });
  }

  melissaFormatter(result: MelissaAddressResponseDto) {
    return result?.Address?.Address;
  }

  searchMelissaAutoComplete(event: AutoCompleteCompleteEvent) {
    if (event.query === "") {
      this.usSuggestions = [] as MelissaAddressResponseDto[];
    } else {
      try {
        this._addressService
          .getMelissaData(event.query, this.countryRegionSelectedId)
          .then((x: MelissaAddressResponseDto[]) => {
            this.usSuggestions = x;
          });
      } catch {
        this.usSuggestions = [] as MelissaAddressResponseDto[];
      }
    }
  }

  onStateSelectionChange(stateid: string) {
    this.parent.patchValue({ [this.formgroupName]: { cityD365: "" } });
    this.getCityListData(stateid, this.countryRegionSelectedId);
  }

  getCityListData(stateid: string, countryid: string) {
    this.showSmallLoader = true;
    this._addressService
      .getCityList(stateid, countryid)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.cityList = res?.data;
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  formattedAddressChange() {
    const formattedAddress = this.parent.get([
      this.formgroupName,
      "addressD365",
    ])?.value;
    if (this.melissaSelection != formattedAddress) {
      this.hideValidateButton = false;
      this.setValidationForAddress();
    } else {
      this.hideValidateButton = true;
      this.removeValidationForAddress();
    }
  }

  enableAndDisabledValidateButton() {
    const cityD365 = this.parent.get([this.formgroupName, "cityD365"])?.value;
    const stateD365 = this.parent.get([this.formgroupName, "stateD365"])?.value;
    const zipCodeD365 = this.parent.get([
      this.formgroupName,
      "zipCodeD365",
    ])?.value;

    if (cityD365 && stateD365 && zipCodeD365) {
      this.hideNonUsAddressSaveButton = false;
    } else {
      this.hideNonUsAddressSaveButton = true;
      this.clearAddress();
    }
  }

  clearAddress() {
    this.parent.patchValue({
      shipTo: {
        streetD365: "",
        addressD365: "",
        rSMJNIShipToEmailD365: "",
        addressBook: "",
        buildingComplimentD365: "",
        apartment_RUD365: "",
        postBoxD365: "",
        countyD365: "",
        streetNumberD365: "",
        districtNameD365: "",
      },
    });

    this.shiftToAddressField = "";
    this.vendorAccountSeletion = "";
    this.addressBookName = "";
  }

  setValidationForAddress() {
    // this.parent.setErrors({ invalid: true });
    this.parent
      .get([this.formgroupName, "validateAddress"])
      ?.setValidators(Validators.required);
    this.parent
      .get([this.formgroupName, "validateAddress"])
      ?.updateValueAndValidity();
  }

  removeValidationForAddress() {
    // this.parent.setErrors({ invalid: false });
    this.parent.get([this.formgroupName, "validateAddress"])?.clearValidators();
    this.parent
      .get([this.formgroupName, "validateAddress"])
      ?.updateValueAndValidity();
  }

  confirm() {
    this.confirmationService.confirm({
      message: "Are you sure that you want to update address?",
      accept: () => {
        this.validateAddress();
      },
      reject: () => {
        this.parent.patchValue({
          [this.formgroupName]: {
            addressD365: this.melissaSelection,
          },
        });
        this.validateAddress();
      },
    });
  }

  saveAddressForNonUs(isTypedAddress = false) {
    this.showSmallLoader = true;
    this._loaderService.setLoaderState(true);
    if (isTypedAddress) {
      this.appartmentList = [];
      this.selectedAppartment = "";
    }
    let address = this.parent.get([this.formgroupName, "addressD365"])?.value;
    if (
      this.countryRegionSelectedId.toLocaleLowerCase() !== "usa" &&
      this.countryRegionSelectedId.toLocaleLowerCase() !== "can"
    ) {
      const addressLine1 = this.parent.get([
        this.formgroupName,
        "addressLine1",
      ])?.value;
      const addressLine2 = this.parent.get([
        this.formgroupName,
        "addressLine2",
      ])?.value;
      const addressLine3 = this.parent.get([
        this.formgroupName,
        "addressLine3",
      ])?.value;
      const cityD365 = this.parent.get([this.formgroupName, "cityD365"])?.value;
      const stateD365 = this.parent.get([
        this.formgroupName,
        "stateD365",
      ])?.value;
      const zipCodeD365 = this.parent.get([
        this.formgroupName,
        "zipCodeD365",
      ])?.value;

      address = `${addressLine1} ${addressLine2} ${addressLine3} ${cityD365} ${stateD365} ${zipCodeD365}`;
    }

    const country = this.countryRegionSelectedId;

    this._addressService
      .checkAddressValidationForNonUs(address, country)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          const item = res[0];
          this.formatResponse = item;
          if (item) {
            this.patchAddress(item);
          }
          this.showSmallLoader = false;
          this.hideNonUsAddressSaveButton = true;
          this._loaderService.setLoaderState(false);
          // if (item) {
          //   if ((item.Results as string).toLowerCase().includes('av')) {
          //     this.addressValidationStatus = false;
          //     this.hideValidateButton = true;
          //     this.removeValidationForAddress();
          //     this.isAddressError = false;
          //   } else {
          //     this.setValidationForAddress();
          //     this.hideValidateButton = false;
          //     this.isAddressError = true;
          //   }
          // }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "No address found");
          this.showSmallLoader = false;
          this.isAddressError = true;
        },
      });
  }

  validateAddress(isTypedAddress = false) {
    this.showSmallLoader = true;
    if (isTypedAddress) {
      this.appartmentList = [];
      this.selectedAppartment = "";
    }
    const address = this.parent.get([this.formgroupName, "addressD365"])
      ?.value as string;
    let melissaAddress = "";
    const country = this.countryRegionSelectedId;
    // Tickets 1134/12444
    if (this.isShipToAddressFromOrder || this.isShipToAddressFromProposal) {
      const addressLine1 = this.parent.get([
        this.formgroupName,
        "addressFormat",
      ])?.value;
      melissaAddress =
        address.replace(/\n/g, " ") ??
        `${addressLine1} ${
          this.parent.get([this.formgroupName, "cityD365"])?.value ?? ""
        } ${this.parent.get([this.formgroupName, "stateD365"])?.value ?? ""} ${
          this.parent.get([this.formgroupName, "zipCodeD365"])?.value ?? ""
        } ${this.parent.get([this.formgroupName, "streetD365"])?.value ?? ""}`;
    } else {
      if (
        this.countryRegionSelectedId.toLocaleLowerCase() !== "usa" &&
        this.countryRegionSelectedId.toLocaleLowerCase() !== "can"
      ) {
        const addressLine1 = this.parent.get([
          this.formgroupName,
          "addressLine1",
        ])?.value;
        const cityD365 = this.parent.get([
          this.formgroupName,
          "cityD365",
        ])?.value;
        const stateD365 = this.parent.get([
          this.formgroupName,
          "stateD365",
        ])?.value;
        const zipCodeD365 = this.parent.get([
          this.formgroupName,
          "zipCodeD365",
        ])?.value;

        melissaAddress = `${addressLine1} ${cityD365} ${stateD365} ${zipCodeD365}`;
      }
    }

    this._addressService
      .checkAddressValidation(melissaAddress, country)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          const item = res[0];
          this.formatResponse = item;
          if (item) {
            this.patchAddress(item);
          }
          this.showSmallLoader = false;
          if (item) {
            if ((item.Results as string)?.toLowerCase()?.includes("av")) {
              this.isAddressValidatedByMelissa = true;
              this.melissaAddressValidatedEvent.emit(true);

              this.addressValidationStatus = false;
              this.hideValidateButton = true;
              this.removeValidationForAddress();
              this.isAddressError = false;
            } else {
              this.isAddressValidatedByMelissa = false;
              this.setValidationForAddress();
              this.hideValidateButton = false;
              this.isAddressError = true;

              this.melissaErrorMessage = this.getMelissaErrorMessage(
                item.Results
              );
            }
          }
        },
        error: () => {
          this.showSmallLoader = false;
          this.isAddressError = true;

          this.isAddressValidatedByMelissa = false;
          this.melissaErrorMessage = "Error validating address.";
        },
      });
  }

  onAppartmentSelection(event: SelectChangeEvent) {
    // this.ngselect.close();
    // const formattedAddress = this.parent.get([
    //   this.formgroupName,
    //   'addressD365'
    // ])?.value;

    if (event && typeof event.value === "string") {
      this.parent.patchValue({
        [this.formgroupName]: {
          buildingComplimentD365: event.value ?? "",
          addressD365: `${this.melissaSelection}${event.value ?? ""}`,
          addressFormat: "",
        },
      });
    } else {
      event.value = "";
      this.parent.patchValue({
        [this.formgroupName]: {
          buildingComplimentD365: event.value ?? "",
          addressD365: `${this.melissaSelection}${event.value ?? ""}`,
          addressFormat: "",
        },
      });
    }
    this.validateAddress();
    this.appartmentFieldStatus = true;
  }

  logValidationErrorsEvent() {
    this.validationErrorEvent.emit();
  }

  malisaFormatterNonUs = (result: MelissaAddressResponseDto) =>
    result?.Address?.Address;

  getMelissaGlobalData(term: string): void {
    if (!term || term.trim() === "") {
      this.nonUSSuggestions = [];
      return;
    }

    this._addressService
      .getMelissaData(term, this.countryRegionSelectedId)
      .then((data: MelissaAddressResponseDto[]) => {
        this.nonUSSuggestions = data;
      })
      .catch(() => {
        this.nonUSSuggestions = [];
      });
  }
  // getMelissaGlobalData: OperatorFunction<string, MelissaAddressResponseDto[]> =
  //   (text$: Observable<string>) =>
  //     text$.pipe(
  //       debounceTime(200),
  //       distinctUntilChanged(),
  //       switchMap(async term => {
  //         if (term === "") {
  //           return [] as MelissaAddressResponseDto[];
  //         } else {
  //           try {
  //             return await this._addressService.getMelissaGlobalData(
  //               term,
  //               this.countryRegionSelectedId,
  //               this.city,
  //               this.state,
  //               this.address2,
  //               this.address3,
  //               this.postalcode
  //             );
  //           } catch {
  //             return [] as MelissaAddressResponseDto[];
  //           }
  //         }
  //       })
  //     );

  patchValueInMak() {
    this.parent.patchValue({
      [this.formgroupName]: {
        melissaAddressKeyD365:
          this.formatResponse?.MelissaAddressKey ??
          this.formatResponse?.MelissaAddressKey,
      },
    });
  }

  patchValueInDeliveryName(name: string) {
    this.parent.patchValue({
      shipTo: {
        deliveryNameD365: name,
      },
    });
  }

  selectedStreetForNonUs(event: AutoCompleteSelectEvent) {
    const item = event.value;
    if (!item.Address.PostalCode) {
      this.melissaSelection = "";
      return;
    }
    this.removeAddressField();

    this.appartmentList = [];
    this.isOpen = true;
    this._addressService
      .checkAddressValidation(
        item.Address.Address,
        this.countryRegionSelectedId
      )
      .subscribe(x => {
        const formatResponse = x[0];
        this.formatResponse = formatResponse;
        if (formatResponse) {
          if (
            (formatResponse.Results as string)?.toLowerCase()?.includes("av")
          ) {
            this.removeValidationForAddress();
            this.isAddressError = false;
            this.hideValidateButton = true;
            this.removeValidationForAddress();
          } else {
            this.setValidationForAddress();
            this.hideValidateButton = false;
            this.isAddressError = true;
          }
          this.patchValueInMak();
        }
      });

    if (item.Address.SubBuilding) {
      this.appartmentList = (item.Address.SubBuilding as string).split(",");
      this.appartmentFieldStatus = false;
      //this.selectedAppartment = this.appartmentList[0] || '';
    }
    this.melissaSelection = `${item.Address.Address1}\n${item.Address.Address2}\n${item.Address.Address3}`;
    const completeAddress = (item.Address.Address as string).replace(
      /,/g,
      "\n"
    );
    let appendedCompleteAddress = completeAddress.trim();
    //If country is USA or CAN don't append the admin area and country name to address
    if (
      this.countryRegionSelectedId !== "USA" &&
      this.countryRegionSelectedId !== "CAN"
    ) {
      appendedCompleteAddress = `${completeAddress}\n${
        item.Address.AdministrativeArea
      }\n${item.Address.CountryName}\n${this.selectedAppartment || ""}`;
    } else {
      appendedCompleteAddress = `${completeAddress}\n${
        this.selectedAppartment || ""
      }`;
    }
    this.parent.patchValue({
      [this.formgroupName]: {
        addressLine1: item.Address.Address1,
        addressLine2: item.Address.Address2,
        addressLine3: item.Address.Address3,
        cityD365: item.Address.Locality,
        stateD365: item.Address.AdministrativeArea,
        streetD365: item.Address.Premise + " " + item.Address.Thoroughfare,
        zipCodeD365: item.Address.PostalCode,
        districtNameD365: item.Address.SubAdministrativeArea,
        postBoxD365: item.Address.PostBox,
        countyD365: item.Address.SubAdministrativeArea,
        streetNumberD365: item.Address.Premise,
        buildingComplimentD365: item.Address.Building,
        addressD365: appendedCompleteAddress,
        melissaAddressKeyD365: this.formatResponse?.MelissaAddressKey ?? "",
      },
    });
    // this.ngselect.open();
    if (item.Address.SubBuilding) {
      this.appartmentList = (item.Address.SubBuilding as string).split(",");
      this.appartmentFieldStatus = false;
      //this.selectedAppartment = this.appartmentList[0] || '';
    }
    this.formattedAddressChange();
    this._addressService
      .getPostalCodeByZipCode(item.Address.PostalCodePrimary)
      .subscribe(res => {
        this.showSmallLoader = true;
        if (!res.data) {
          this.showSmallLoader = false;
          return;
        }
        this._addressService
          .getCityList(res.data.stateId, res.data.countryRegionId)
          .pipe(
            map(cityResponse => {
              this.cityList = cityResponse.data;

              return cityResponse.data.filter(
                city =>
                  city.cityKeyD365?.includes(res?.data?.cityId) &&
                  city.countryRegionIdD365 == res?.data?.countryRegionId &&
                  city.countyIdD365 == res?.data?.countyId &&
                  city.stateIdD365 == res?.data?.stateId
              );
            })
          )
          .pipe(untilDestroyed(this))
          .subscribe({
            next: () => {
              this.showSmallLoader = false;
            },
            error: () => {
              this.showSmallLoader = false;
            },
          });
      });
  }

  patchFormInHeaderToShip(address: Address) {
    this.parent.patchValue({
      shipTo: {
        countryRegionIdD365: address.countryRegionIdD365,
        zipCodeD365: address.zipCodeD365,
        streetD365: address.streetD365,
        cityD365: address.cityD365,
        stateD365: address.stateD365,
        countyD365: address.countyD365,
        streetNumberD365: address.streetNumberD365,
        buildingComplimentD365: address.buildingComplimentD365,
        apartment_RUD365: address.apartment_RUD365 ?? "",
        postBoxD365: address.postBoxD365,
        districtNameD365: address.districtNameD365,
        addressLocationNumber: parseInt(address.locationNumberD365 ?? "0"),
        addressD365: address?.addressD365?.replace("<br/>", "\n"),
      },
    });
  }

  patchFormInHeaderToShipAddress(
    header: SalesOrderHeader | PurchaseOrderHeader | QuotesHeader
  ) {
    if (
      "addressSelectionD365" in header &&
      header.addressSelectionD365 == "TBD"
    ) {
      this.onDeliveryAddressChange(header.addressSelectionD365);
    } else if (
      "addressSelectionD365" in header &&
      (header.addressSelectionD365 == "Multiple ship-to" ||
        header.addressSelectionD365 == "Multi Ship To" ||
        header.addressSelectionD365?.toLowerCase().includes("drop"))
    ) {
      this.onDeliveryAddressChange("Multi Ship To");
    }

    this.parent.patchValue({
      shipTo: {
        attentionInformationD365: header.attentionInformationD365,
        locationD365: header.locationD365 ?? "",
        rSMJNIShipToEmailD365: header.rsmjniShipToEmail ?? "",
        deliveryNameD365: header.deliveryNameD365 ?? "",
      },
    });
    this.disableDeliveryName();
    this.showName = true;
  }

  searchVendorName() {
    this.searchVendor$
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          this.showSmallLoader = true;
          const accountNumberOrName = searchitem;
          this.vendorList = [];
          if (accountNumberOrName != "" && accountNumberOrName != undefined) {
            return this._samplepoListingService.getVendorByNameAndAccountNumberFilter(
              accountNumberOrName
            );
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.vendorList = res.data as unknown as GetAllVendorsDto[];
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  onVendorSearchOpenToggle(mydrop: Popover, event: Event, target: HTMLElement) {
    mydrop.show(event, target);
  }

  onVendorAddressBookSelect(
    popover: Popover,
    target: HTMLInputElement,
    event: MouseEvent
  ) {
    if (this.addressBookList?.length > 1) {
      popover.show(event, target);
    } else {
      popover.hide();
    }
  }

  onVendorAddressBookSelection(
    event: Address,
    vendorAddressBookToggle: Popover
  ) {
    this.addressBookName = event.descriptionD365 ?? "";
    this.parent.patchValue({
      shipTo: {
        countryRegionIdD365: event.countryRegionIdD365,
        zipCodeD365: event.zipCodeD365,
        streetD365: event.streetD365,
        cityD365: event.cityD365,
        stateD365: event.stateD365,
        countyD365: event.countyD365,
        streetNumberD365: event.streetNumberD365,
        buildingComplimentD365: event.buildingComplimentD365,
        apartment_RUD365: event.apartment_RUD365 ?? "",
        postBoxD365: event.postBoxD365,
        districtNameD365: event.districtNameD365,
        addressLocationNumber: parseInt(event.locationNumberD365 ?? ""),
        addressD365: event?.addressD365?.replace("<br/>", "\n"),
        deliveryNameD365: event.descriptionD365,
      },
    });
    if (vendorAddressBookToggle) {
      vendorAddressBookToggle.hide();
    }
  }

  onVendorAccountSelection(
    data: GetVendorSearchResponseDto,
    vendorAccount: Popover,
    event: MouseEvent
  ) {
    this.clearShifToForm();
    this.vendorAccountSeletion = data.vendorName;
    const partyNumber = data.partyNumber ?? "";
    if (
      this.vendorAccountSeletion != undefined &&
      this.vendorAccountSeletion != ""
    ) {
      this._samplepoListingService
        .getVendorAddressByPartyNumber(partyNumber)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: (res: GenericResponseDto<Address[]>) => {
            if (res.data != null) {
              this.addressBookList = res.data;
              this.patchValueInVendorAccount(
                data.vendorAccountNumber,
                this.vendorAccountSeletion
              );
              if (this.addressBookList.length === 1) {
                this.onVendorAddressBookSelection(
                  this.addressBookList[0],
                  {} as Popover
                );
              }
              if (this.addressBookList?.length > 1) {
                event.preventDefault();
                const native = this.vendorShipToNameInput.nativeElement;
                this.vendoraddressbookPopOver.show(event, native);
              } else {
                this.vendoraddressbookPopOver.hide();
              }
            }
          },
        });
    }
    vendorAccount.hide();
  }

  patchValueInVendorAccount(vendorAccount: string, vendorName: string) {
    this.parent.patchValue({
      shipTo: {
        shipToVendorAccountD365: vendorAccount,
        shipToVendorAccountNameD365: vendorName,
      },
    });
  }

  getLoaderStatus(status: boolean) {
    this.showSmallLoader = status;
  }

  patchFormDeliveryAddress(addressSelectionName: string) {
    this.parent.patchValue({
      shipTo: {
        addressSelectionName: addressSelectionName,
      },
    });
  }

  clearShipToAddressForm() {
    this.shiftToAddressField = "";
    //this.countryRegionSelectedId = '';
    this.vendorAccountSeletion = "";
    this.addressBookName = "";
    this.shipToAddress = false;
    this.vendorAccountAndBook = false;
    this.showAddress = true;
  }

  clearShipToMultiForm() {
    this.parent.patchValue({
      shipTo: {
        deliveryNameD365: "",
        attentionInformationD365: "",
        rSMJNIShipToEmailD365: "",
        addressD365: "",
        addressFormat: "",
        locationD365: "",
      },
    });
  }

  enableMultiShipTo() {
    this.parent.get(["shipTo", "attentionInformationD365"])?.enable();
    this.parent.get(["shipTo", "locationD365"])?.enable();
    this.parent.get(["shipTo", "addressFormat"])?.disable();
    this.parent.get(["shipTo", "addressD365"])?.disable();
    this.parent.get(["shipTo", "deliveryNameD365"])?.disable();
  }

  enableClientBillingDetails() {
    this.parent.get(["shipTo", "attentionInformationD365"])?.enable();
    this.parent.get(["shipTo", "locationD365"])?.enable();
  }

  getMelissaErrorMessage(result: string): string {
    const errorCode = result.trim();
    const errorMessage = (
      this.melissaStatusCodes as Record<string, { longDescription: string }>
    )[errorCode] || { longDescription: "Unknown error" };
    this.isAddressError = true;
    return errorMessage.longDescription;
  }

  continueWithoutValidation() {
    this.modalOpen = true;
    this.isAddressValidatedByMelissa = true;
    this.hideValidateButton = true;
    this.isMelissaValidationIgnore = true;
    this.melissaValidationIgnoreEvent.emit(this.isMelissaValidationIgnore);
  }

  onConfirmContinueWithoutValidation() {
    this.removeValidationForAddress();
    this.isAddressError = false;
    this.modalOpen = false;
    if (this.formErrors["addressD365"]) {
      this.formErrors["addressD365"] = "";
    }
  }

  clearValidationMessages() {
    // Clear specific or all validation messages here.
    this.isAddressError = false;
    if (this.formErrors) {
      this.formErrors["addressD365"] = "";
    }
  }

  onCancelContinueWithoutValidation() {
    this.hideValidateButton = false;
    this.modalOpen = false;
  }

  getCountryRegionListData() {
    this._addNewClientService
      .getCountryRegionList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.countryRegionList = res?.data;
          const existingCountryRegionValue = this.parent.get([
            "shipTo",
            "countryRegionIdD365",
          ])?.value;
          if (
            !existingCountryRegionValue ||
            existingCountryRegionValue === ""
          ) {
            this.parent.patchValue({
              shipTo: {
                countryRegionIdD365:
                  this.countryRegionList.find(
                    x => x.countryRegionD365 === "USA"
                  )?.countryRegionD365 ?? "",
              },
            });
          }
        },
      });
  }
}
